import { render, staticRenderFns } from "./403.vue?vue&type=template&id=fd85cfba&scoped=true"
import script from "./403.vue?vue&type=script&lang=js"
export * from "./403.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fd85cfba",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/www/wwwroot/saas_fe/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('fd85cfba')) {
      api.createRecord('fd85cfba', component.options)
    } else {
      api.reload('fd85cfba', component.options)
    }
    module.hot.accept("./403.vue?vue&type=template&id=fd85cfba&scoped=true", function () {
      api.rerender('fd85cfba', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/exception/403.vue"
export default component.exports